<script setup lang="ts">
export interface AppHeaderVisibleLinksProps {
  links: IHeaderLink[];
}

const { t } = useI18n();
const props = defineProps<AppHeaderVisibleLinksProps>();
</script>

<template>
  <template v-if="props.links.length">
    <BaseButton
      v-for="link in props.links"
      :key="link.id"
      class="block flex-none font-medium snap-start !leading-5 hover:!text-black hover:!no-underline"
      type="secondary"
      :name="link.title"
      :tag="link.href.includes('http') ? 'a' : 'nuxt-link'"
      :to="link.href.includes('http') ? {} : link.href"
      :href="link.href.includes('http') ? link.href : undefined"
      exact-active-class="!text-[var(--base-primary-color)]"
      link
    >
      <span class="px-6">{{ link.id === 'following' ? t('labels.following') : link.title }}</span>
    </BaseButton>
  </template>
</template>
